import { observer } from 'mobx-react-lite'
import { BellIcon } from '@heroicons/react/20/solid'
import { useInjection } from '@core/providers/inversify-react.provider'
import { Drawer } from '@ui-kit/drawer.component'
import { EmptyState, SkeletonRows } from '@ui-kit/state.component'
import { FeedbackComponent } from '@core/feedback/feedback.component'
import { InboxBellPresenter } from './inbox-bell.presenter'

/** What's been shared with you — see InboxRepository/InboxBellPresenter's class jsdoc. */
export const InboxBellComponent = observer(() => {
  const presenter: InboxBellPresenter = useInjection(InboxBellPresenter)
  const vm = presenter.viewModel

  return (
    <>
      <button
        type="button"
        onClick={presenter.openDrawer}
        className="relative -m-2.5 flex items-center justify-center rounded-md p-2.5 text-shell-ink-secondary hover:text-shell-ink"
        aria-label={vm.title}
        title={vm.title}
      >
        <BellIcon aria-hidden="true" className="size-6" />
        {vm.unreadCount > 0 && (
          <span
            className="absolute top-1 right-1 flex size-4 items-center justify-center rounded-full bg-shell-accent text-[10px] font-medium text-white"
            aria-hidden="true"
          >
            {vm.unreadCount > 9 ? '9+' : vm.unreadCount}
          </span>
        )}
      </button>

      <Drawer open={vm.open} title={vm.title} closeLabel={vm.closeLabel} onClose={presenter.closeDrawer}>
        <FeedbackComponent scope="inbox" />

        {vm.isLoading && <SkeletonRows label={vm.title} rows={3} />}

        {vm.showEmpty && <EmptyState title={vm.emptyTitle} />}

        {!vm.isLoading && vm.rows.length > 0 && (
          <ul className="divide-y divide-shell-border">
            {vm.rows.map((row) => (
              <li key={row.itemId}>
                <button
                  type="button"
                  onClick={row.open}
                  className="flex w-full flex-col gap-0.5 px-1 py-3 text-left hover:bg-shell-surface-muted"
                >
                  <span className="text-sm text-shell-ink">{row.headline}</span>
                  <span className="text-xs text-shell-ink-secondary">{row.timeLabel}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </Drawer>
    </>
  )
})
